import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  NAME,
  MOBILE,
  EMAIL,
  ADDRESS,
  NOTES,
  CAR_MODEL,
  CAR_COLOR,
  CAR_LICENSE,
  UMBRELLA_NUMBER,
  UMBRELLA_INSTRUCTION,
} from 'constants/translations';

const OrderInvoiceUserInfo = ({ lang, direction, order, isGift, addressTranslation, translate }) => {
  const { userData: { recipient, name, phoneNumber, email, address, car } = {} } = order || {};
  return (
    <div className={cx('flex p-4 mb-6', lang === 'ar' && 'flex-row-reverse')}>
      <div className="flex flex-col w-1/2">
        <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
          <span className="text-sm font-bold" style={{ direction }}>
            {translate(NAME)}:
          </span>
          <span className="text-sm px-3" style={{ direction }}>
            {isGift ? recipient?.name : name}
          </span>
        </div>
        <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
          <span className="text-sm font-bold" style={{ direction }}>
            {translate(MOBILE)}:
          </span>
          <span className="text-sm px-3">{isGift ? recipient?.phoneNumber : phoneNumber}</span>
        </div>
        {!isGift && (
          <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
            <span className="text-sm font-bold" style={{ direction }}>
              {translate(EMAIL)}:
            </span>
            {email ? (
              <span className="text-sm px-3" style={{ direction }}>
                {email}
              </span>
            ) : (
              <span className="text-sm font-bold px-3" style={{ direction }}>
                -
              </span>
            )}
          </div>
        )}
      </div>
      <div className="flex flex-col w-1/2">
        {address && (
          <>
            <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
              <span className="text-sm font-bold" style={{ direction }}>
                {translate(ADDRESS)}:
              </span>
              <span className="text-sm px-3" style={{ direction }}>
                {addressTranslation(address)}
              </span>
            </div>
            <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
              <span className="text-sm font-bold" style={{ direction }}>
                {translate(NOTES)}:
              </span>
              {address.notes ? (
                <span className="text-sm px-3" style={{ direction }}>
                  {address.notes}
                </span>
              ) : (
                <span className="text-sm font-bold px-3" style={{ direction }}>
                  -
                </span>
              )}
            </div>
          </>
        )}

        {car && (
          <>
            <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
              <span className="text-sm font-bold" style={{ direction }}>
                {translate(CAR_MODEL)}:
              </span>
              <span className="text-sm px-3" style={{ direction }}>
                {car.make || car.model}
              </span>
            </div>
            <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
              <span className="text-sm font-bold" style={{ direction }}>
                {translate(CAR_COLOR)}:
              </span>
              <span className="text-sm px-3" style={{ direction }}>
                {car.color}
              </span>
            </div>
            <div className={cx('flex py-1', lang === 'ar' && 'flex-row-reverse')}>
              <span className="text-sm font-bold" style={{ direction }}>
                {translate(CAR_LICENSE)}:
              </span>
              {order.userData.car.license ? (
                <span className="text-sm px-3" style={{ direction }}>
                  {car.license}
                </span>
              ) : (
                <span className="text-sm font-bold px-3" style={{ direction }}>
                  -
                </span>
              )}
            </div>
          </>
        )}
        {order.beachUmbrella && (
          <div className="w-full flex flex-col" style={{ direction }}>
            <span className="text-sm pb-1">
              <span className="font-bold">{translate(UMBRELLA_NUMBER)}</span> {order.beachUmbrella?.number}
            </span>
            {order.beachUmbrella?.specialDirections && (
              <span className="text-sm">
                <span className="font-bold">{translate(UMBRELLA_INSTRUCTION)}</span>
                {order.beachUmbrella?.specialDirections}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

OrderInvoiceUserInfo.propTypes = {
  lang: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  order: PropTypes.shape({
    userData: PropTypes.shape({
      recipient: PropTypes.string,
      name: PropTypes.string,
      phoneNumber: PropTypes.number,
      email: PropTypes.string,
      address: PropTypes.shape({
        area: PropTypes.shape({ cityTitleEn: PropTypes.string, cityTitleAr: PropTypes.string }),
      }),
      car: PropTypes.string,
    }),
  }),
  isGift: PropTypes.bool,
  addressTranslation: PropTypes.func,
  translate: PropTypes.func,
};
export default OrderInvoiceUserInfo;
